import Header from "../components/Header/Header";
import { AppChildrenWrapper, AppWrapper } from "./AppLayout.styled";

const AppLayout = ({ children }) => {
  return (
    <AppWrapper className="AppLayout-AppWrapper">
      <Header />
      <AppChildrenWrapper className="AppChildrenWrapper">
        {children}
      </AppChildrenWrapper>
    </AppWrapper>
  );
};

export default AppLayout;
